export default __webpack_public_path__ + "contentmodules/CTM_MasterScorecardbb8605242c4adce37ba46206c50b386e.png";